import Axios from "@/Axios";

class SectionService{

    async getSections(data={}){
        return await Axios.get('wms.wms.api.section.get_sections',{
            params:data
        })
    }
    async createSection(data){
      return await Axios.post('wms.wms.api.section.create_section',data)
    }
    async updateSection(data) {
        return await Axios.put(`wms.wms.api.section.update_section`, data)
    }
    async getSection(sectionId) {
        return await Axios.get('wms.wms.api.section.get_section_by_id', { params: { section: sectionId } })
    }
    async deleteSection(section){
        const transformedSection = section.map(item => ({ name: item }));
        return await Axios.delete('wms.wms.api.section.delete_sections',{data:{section_name:transformedSection}})
    }

}
export default new SectionService()